import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderNav } from '../../../header-nav/header-nav';
import { Header } from '../../../header/header';

@Component({
  selector: 'app-authenticated-layout',
  imports: [Header, HeaderNav, RouterModule],
  template: `
    <div class="app-container">
      <app-header></app-header>
      <app-header-nav></app-header-nav>
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styleUrl: './authenticated-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticatedLayout {}
